import { sortBy } from 'lodash';
import {
  QueryFunction,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';

import { QueryKey } from 'enums';
import { TradeMethod } from 'types';

export function useTradeMethodsQuery<TError>(
  queryKey: QueryKey,
  queryFn: QueryFunction<TradeMethod[], QueryKey>,
  options?:
    | Omit<
        UseQueryOptions<TradeMethod[], TError, TradeMethod[], QueryKey>,
        'queryKey' | 'queryFn'
      >
    | undefined,
): UseQueryResult<TradeMethod[]> {
  return useQuery(queryKey, queryFn, {
    ...options,
    select: (tradeMethods) => sortBy(tradeMethods, ['archived']),
  });
}
